import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import { useQuery, useMutation } from '@apollo/client';
import { useForm } from 'react-hook-form';

import { Fields, defaultValues, prepareInput } from 'app/src/elements/forms';
import { Button } from 'app/src/elements/buttons';
import { Loading } from 'app/src/elements/DataState';
import { Title } from 'app/src/styles';
import { useNavigate, useParams } from 'app/src/utils/routing';

import { EVENT_TYPE, EVENT_TYPES, UPDATE_EVENT_TYPE } from './queries';
import { FIELDS } from './new';

const EventType = () => {
  const { id } = useParams();
  const [formStatus, setFormStatus] = useState();
  const navigate = useNavigate();

  const {
    control, handleSubmit, reset, watch, formState: { errors }
  } = useForm({
    defaultValues: defaultValues({ fields: FIELDS })
  });

  const { data } = useQuery(EVENT_TYPE, { variables: { id } });
  const { data: selects } = useQuery(EVENT_TYPES);

  useEffect(() => {
    if (data) {
      reset(defaultValues({ fields: FIELDS, resource: data.eventType }));
    }
  }, [data]);

  const [updateEventType] = useMutation(UPDATE_EVENT_TYPE, {
    onCompleted: () => navigate('/event-types'),
  });

  const onSubmit = input => {
    setFormStatus('submitting');
    updateEventType({
      variables: { input: { id, ...prepareInput(input, FIELDS) } }
    });
  };

  const fields = { ...FIELDS };

  if (selects) {
    fields.parentId.select = [
      { value: '', label: 'NONE' },
      ...selects.eventTypes
        .filter(entry => entry.id !== id)
        .map(entry => ({ value: entry.id, label: entry.name }))
    ];
  }

  if (watch('hasAmount')) {
    fields.amountLabel = { ...fields.amountLabel, type: 'string' };
  }

  return (
    <View>
      <Title>{data?.eventType.name}</Title>

      <Fields
        fields={fields}
        control={control}
        errors={errors}
      />

      {'submitting' === formStatus ? (
        <Loading />
      ) : (
        <Button label="Save" onPress={handleSubmit(onSubmit)} wide />
      )}
    </View>
  );
};

export default EventType;
